import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  heading: props => ({
    color: theme.palette.primary.main,
    fontFamily: 'Dazzed',
    lineHeight: '24px',
    fontSize: `${props.xs}px`,

    [theme.breakpoints.up('sm')]: {
      fontSize: `${props.sm}px`
    },
    [theme.breakpoints.up('md')]: {
      fontSize: `${props.md}px`
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: `${props.lg}px`
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: `${props.xl}px`
    }
  })
}))

const DazzedHeadingForGrid = ({ className, regular, semibold, children, style, xs = 10, sm, md, lg, xl }) => {
  const classes = useStyles({ xs, sm: sm || xs, md: md || xs, lg: lg || xs, xl: xl || xs })

  return (
    <div
      className={[classes.heading, className].filter(Boolean).join(' ')}
      style={{ fontWeight: regular ? 400 : semibold ? 500 : 600, ...style }}
    >
      {children}
    </div>
  )
}

export default DazzedHeadingForGrid
